import { HelpCircleFilled } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import { LegacyPopover } from '@creditornot/cb-popover';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React, { ReactNode } from 'react';
import styled, { useTheme } from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography as T } from 'common/typography';

type Props = {
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
};

const Root = styled(LegacyPopover)`
  margin-inline-start: 8px;
  line-height: 0;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin-inline-start: 0;
    padding: 8px;
  }
`;

const Content = styled.div`
  width: 200px;
  padding: 16px;
`;

const Title = styled(T.Body3)`
  display: block;
  font-weight: 700;
`;

const Description = styled(T.Body3)`
  display: block;
`;

const DefaultIcon = styled(HelpCircleFilled).attrs({
  width: 12,
  height: 12,
})`
  fill: ${cssThemedValue({ light: colors.pepper24, dark: colors.salt72 })};
`;

const Tooltip = ({ description, title, icon }: Props) => {
  const theme = useTheme();
  return (
    <Root
      content={
        <Content>
          {title && <Title>{title}</Title>}
          {description && <Description>{description}</Description>}
        </Content>
      }
      contentZIndex={999999}
      disableContentPadding
      placement={theme.cbDirection === 'ltr' ? 'right' : 'left'}
    >
      {icon || <DefaultIcon />}
    </Root>
  );
};

export default Tooltip;
